import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MenuItem } from 'src/app/bo/menuItem';
import { UtilisateurService } from 'src/app/services/utilisateur.service';

@Component({
  selector: 'app-operations',
  templateUrl: './operations.component.html',
  styleUrls: ['./operations.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OperationsComponent implements OnInit {
  isLoaded = signal(false);

  arrayMenu: MenuItem[] = [
    {
      translateId: 'OPERATIONS.DRILL_ACTIVITY_CHART',
      translatedName: 'Drilling',
      activeClass: 'active',
      tab: 1,
      routePath: 'drill-activity-chart'
    },
    {
      translateId: 'OPERATIONS.DELIVERY_ACTIVITY_CHART',
      translatedName: 'Delivery',
      activeClass: 'active',
      tab: 2,
      routePath: 'delivery-activity-chart'
    }
  ];

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    public utilService: UtilisateurService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // Redirect to first sub-route if on the base operations path
    this.route.url.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      if (!this.route.firstChild) {
        this.router.navigate(['drill-activity-chart'], { relativeTo: this.route });
      }
    });

    this.isLoaded.set(true);
  }

  protected getTabLink(routePath?: string): string[] {
    if (!routePath) {
      return [];
    }

    const mode = this.route.firstChild?.snapshot.paramMap.get('mode');
    const date = this.route.firstChild?.snapshot.paramMap.get('date');

    if (this.isValidMode(mode) && this.isValidDate(date)) {
      return [routePath, mode, date];
    }

    return [routePath];
  }

  private isValidMode(value: string | null | undefined): value is 'week' | 'month' {
    return value === 'week' || value === 'month';
  }

  private isValidDate(value: string | null | undefined): value is string {
    return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value);
  }
}
